<template>
  <div class="mode_params" v-if="hasParams">
    <div v-if="hasParams">
      <span class="l_title">Дополнительные параметры</span>
      <div class="mode_params__label" v-for="(param, key) in modeParams">
        <template v-if="param.type === 'boolean'">
          <label class="mode_params__check">
            <input v-model="param.value" type="checkbox" class="uk-checkbox" :name="key">
            <span>{{ param.desc }}</span>
          </label>
        </template>
        <template v-if="param.type === 'range'">
          <span>{{ param.desc }} ({{ param.value }})</span>
          <input v-model="param.value" type="range" class="uk-range" :min="param.min" :max="param.max" :step="param.step" :name="key">
        </template>
        <template v-if="param.type === 'array'">
          <span>{{ param.desc }}</span>
          <button type="button" @click="param.qnt++" class="uk-button uk-button-text">Добавить</button>
          <div class="mode_params__arr" v-for="i in param.qnt" v-if="param.values[i-1]">
            <div>
              <span>Буква</span>
              <input type="text" :name="param.array_params[0]" v-model="param.values[i-1][param.array_params[0]]">
            </div>
            <div>
              <span>Замена</span>
              <input type="text" :name="param.array_params[1]" v-model="param.values[i-1][param.array_params[1]]">
            </div>
            <span uk-icon="close" uk-tooltip="Удалить" @click="removeArrParam(i, 'changes')"></span>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "mode_params",
  data() {
    return {}
  },
  props: {
    items: '',
    params: '',
  },
  watch: {
    'modeParams': {
      handler() {
        if (this.modeParams && this.modeParams.changes) this.changeArrayValues();
      },
      deep: 'true'
    }
  },
  computed: {
    hasParams() {
      let mode = this.params.selected_mode;
      if (mode) {
        return mode.params ? true : false;
      }
      return false;
    },
    modeParams() {
      if (this.params.selected_mode) {
        return this.params.selected_mode.params;
      }
    },
  },
  methods: {
    changeArrayValues() {
      if (typeof this.modeParams.changes !== 'undefined') {
        let values = this.modeParams.changes.values;
        let qnt = this.modeParams.changes.qnt;
        if (values.length < qnt) {
          let num = qnt - values.length;
          for (let i = 0; i < num; i++) {
            values.push({
              'letter': '',
              'change': ''
            });
          }
        }
      }
    },
    removeArrParam(i, param) {
      let array = this.modeParams[param];
      _.compact(array.values.splice((i - 1), 1));
      array.qnt--;

    },
  },
  mounted() {

  }
}
</script>
